import { render, staticRenderFns } from "./VLabelEdit.vue?vue&type=template&id=0b133f86&scoped=true&"
import script from "./VLabelEdit.vue?vue&type=script&lang=js&"
export * from "./VLabelEdit.vue?vue&type=script&lang=js&"
import style0 from "./VLabelEdit.vue?vue&type=style&index=0&id=0b133f86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b133f86",
  null
  
)

export default component.exports